import React, { useState } from 'react';
import MultipleChoiceExercise from './MultipleChoiceExercise';
import './MultipleChoiceExerciseBoard.css';

const BOARD_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    width: 48, height: 48, borderRadius: 12,
    background: 'linear-gradient(135deg, #0d9488 0%, #0891b2 100%)',
    marginRight: 20, flexShrink: 0,
  }}>
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <polyline points="8 12 11 15 16 9"/>
    </svg>
  </span>
);

const MultipleChoiceExerciseBoard = ({
  exerciseData,
  onUpdate,
  isSelected,
  onSelect,
  onExpand,
  isExpanded: isExpandedProp,
  onClose,
  isStudent = false,
  myState = {},
  otherState = {},
  updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;

  const { mode, sentences, passage, gaps, title, level } = exerciseData || {};

  const hasValidData = mode === 'sentences'
    ? (Array.isArray(sentences) && sentences.length > 0)
    : (typeof passage === 'string' && Array.isArray(gaps) && gaps.length > 0);

  if (!hasValidData) {
    return <div className="mc-board-error"><p>Error: Invalid Multiple Choice exercise data</p></div>;
  }

  const getMeta = () => {
    if (mode === 'sentences') {
      const count = Array.isArray(sentences) ? sentences.length : 0;
      return `${count} question${count !== 1 ? 's' : ''} · Level: ${level || 'B1'}`;
    }
    const count = Array.isArray(gaps) ? gaps.length : 0;
    return `${count} gap${count !== 1 ? 's' : ''} · Reading passage · Level: ${level || 'B1'}`;
  };

  return (
    <div className="mc-exercise-board">
      {!isExpanded ? (
        <div
          className={`mc-board-preview unified-exercise-preview mc-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={() => {
            if (isExpandedProp === undefined) setIsExpandedLocal(true);
            if (onSelect) onSelect();
            if (onExpand) onExpand();
          }}
        >
          {BOARD_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'Multiple Choice Exercise'}</div>
            <div className="unified-preview-meta">{getMeta()}</div>
          </div>
          <button className="unified-preview-btn">Start Exercise</button>
        </div>
      ) : (
        <div className="mc-board-expanded">
          <MultipleChoiceExercise
            mode={mode}
            sentences={sentences}
            passage={passage}
            gaps={gaps}
            title={title}
            level={level}
            onClose={() => {
              if (isExpandedProp === undefined) setIsExpandedLocal(false);
              if (onClose) onClose();
            }}
            onUpdate={onUpdate}
            isBoard={true}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default MultipleChoiceExerciseBoard;
